import script from "./addWarehousing.vue?vue&type=script&setup=true&lang=ts"
export * from "./addWarehousing.vue?vue&type=script&setup=true&lang=ts"

import "./addWarehousing.vue?vue&type=style&index=0&id=d08b4814&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d08b4814"]])

export default __exports__